import { links } from 'bzx-common/src/config/appConfig'
import _ from 'lodash'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Icon } from 'ui-framework'

export function Socials() {
  return (
    <div className="socials__grid">
      <div className="panel--simple md-padded-2">
        <h3 className="title-section">Our Channels</h3>
        <div className="margin-bottom-2">
          <ExternalLink className="link--discreet" href={links.blog.url}>
            <Icon name={links.blog.icon} size={24} /> {links.blog.title}
          </ExternalLink>
        </div>
        <h4 className="h4--muted">Social networks</h4>
        <div className="socials__networks margin-bottom-2">
          {_.map(links.socials, (social, key) => (
            <div key={key}>
              <ExternalLink className="link--discreet" href={social.url}>
                <Icon name={social.icon} size={24} /> {social.title}
              </ExternalLink>
            </div>
          ))}
        </div>

        <h4 className="h4--muted">Developers</h4>
        <div className="margin-bottom-1">
          <ExternalLink className="link--discreet" href={links.github.url}>
            <Icon name={links.github.icon} size={24} /> {links.github.title}
          </ExternalLink>
        </div>
      </div>

      <div className="panel--simple md-padded-2">
        <h3 className="title-section">Crypto Platforms</h3>
        <div className="socials__networks">
          {links.cryptoPlatforms.map((platform) => (
            <div key={platform.title}>
              <ExternalLink className="link--discreet" href={platform.url}>
                <Icon name={platform.icon} size={24} /> {platform.title}
              </ExternalLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default React.memo(Socials)
